interface BreadcrumbProps {
  items: { label: string; to?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-xs md:text-sm text-foreground-500">
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          {idx > 0 && <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-300"><i className="ri-arrow-right-s-line" /></span>}
          {item.to ? (
            <a href={item.to} className="hover:text-primary-600 transition-colors duration-200 cursor-pointer">
              {item.label}
            </a>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}